import _ from "lodash";
/**
 * Transforms object keys from snake_case to camelCase
 * @param  {Object} obj object with snake case keys
 * @return {Object} an object with camel case keys
 * @example
 * //returns {
 *     testKey: 0
 * }
 * snakeCaseObjectKeysToCamelCase({
 *     test_key: 0
 * })
 */
const snakeCaseObjectKeysToCamelCase = obj => {
  return _.transform(obj, (acc, value, key) => {
    acc[_.camelCase(key)] = _.isObject(value) ? snakeCaseObjectKeysToCamelCase(value) : value;
  });
};
export default snakeCaseObjectKeysToCamelCase;
